import { Box, Tab, Tabs } from "@mui/material";
import PageBreadcrumb from "Common/Components/PageBreadcrumb/PageBreadcrumb";
import PageContainer from "Common/Components/PageContainer/PageContainer";
import { MecordColors } from "Constants/Color";
import { useFormik } from "formik";
import { showCustomSwal } from "helpers/swalHelper";
import { useRef, useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { City, Country, State } from "country-state-city";
import {
  addSupplier,
  updateSupplier,
  fetchSupplierById,
} from "slices/Masters/supplier/thunk";
import { clearTableState } from "helpers/ClearTableState/ClearTableState";
import { useScrollToFormikError } from "hooks/useScrollToFormikError";
import { TableKeys } from "Constants/TableKeys/TableKeys";
import * as Yup from "yup";
import BranchDetails from "./BranchDetails";
import KYCDetails from "./KYCDetails";
import ProductDetails from "./ProductDetails";
import SupplierDetails from "./SupplierDetails";
import LoadingSpinner from "components/LoadingSpinner";
const emailRegex = /^\S+@\S+\.\S+$/;

const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;
const cinRegex = /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/i;

// ============ Tab 1 Supplier Details Tab States=====================

interface TableFormikTypes {
  name: string;
  designation: string;
  email: string;
  phone_number: string;
}
// ===========================================================
// ============Tab 2 Item And KYC Tab States=====================

interface ItemRow {
  item_name?: string;
  unit?: string;
  item_id?: string;
  item_unit_id?: string;
}
interface KYCDocumentsFormikTypes {
  gst_no: string;
  gst_document_file: any;
}
interface OthersDocumentsFormikTypes {
  document_number: string;
  document_type: string;
  document_file: any;
}
interface kycDetailsFormikTypes {
  is_kyc_approved: boolean;
  is_pan_details: boolean;
  pan_document_name: string;
  pan_document: any;
  is_gst_details: boolean;
  gst_document_name: string;
  gst_document: any;
  is_cin_details: boolean;
  cin_document_name: string;
  cin_document: any;
  is_other_details: boolean;
}
interface ItemOption {
  item_id: string;
  item_name: string;
}

interface BranchFormikTypes {
  is_primary: boolean;
  branch_name: string;
  branch_email: string;
  branch_phone_number: string;
  contact_name: string;
  contact_email: string;
  contact_phone_number: string;
  is_gst_details: boolean;
  gst_document_name: string;
  gst_document: string;
  address: string;
  pincode: string;
  city: any;
  state: any;
  country: any;
}
// ===========================================================
// ============Tab 3 Branch Details Tab States=====================
interface Item {
  item_name: string;
  unit_name: string;
  unit_price: number | string;
  lead_time: number | string;
  capacity: number | string;
  item_status: boolean;
}
const SupplierForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { id: supplier_id } = useParams<{ id: string }>();
  const isEdit = Boolean(supplier_id);
  const [activeTab, setActiveTab] = useState("supplier");
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const [loadingSupplier, setLoadingSupplier] = useState<boolean>(false);
  const [countries, setCountries] = useState<any>([]);
  const [states, setStates] = useState<any>([]);
  const [cities, setCities] = useState<any>([]);

  useEffect(() => {
    const countryList = Country.getAllCountries();
    setCountries(countryList);
  }, []);

  const [originalDocuments, setOriginalDocuments] = useState<{
    pan_document_url?: string | null;
    gst_document_url?: string | null;
    cin_document_url?: string | null;
  }>({});

  // =====================Tab 1 Supplier Details Tab States====================

  // ---------------------- Main Formik (Supplier) ---------------------- //
  const supplierDetailsFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      supplier_name: "",
      supplier_type: "",
      on_boarding_date: "",
      email: "",
      phone_number: "",
      contacts: [],
    },
    validationSchema: Yup.object({
      supplier_name: Yup.string().trim().required("Supplier Name is required"),
      supplier_type: Yup.string().required("Supplier Type is required"),
      on_boarding_date: Yup.string().required("On Boarding Date is required"),
      email: Yup.string()
        .trim()
        .matches(
          emailRegex,
          "Enter a valid email address (e.g., name@example.com)",
        )
        .required("Email is required"),
      phone_number: Yup.string().trim().required("Phone number is required"),
      contacts: Yup.array(),
    }),
    onSubmit: async (values) => {
      if (values?.contacts?.length === 0) {
        showCustomSwal({
          icon: "warning",
          text: "At least One contact person is required",
        });
        return;
      }
      setActiveTab("kyc");
    },
  });
  const contactPersonTableFormik = useFormik<TableFormikTypes>({
    enableReinitialize: true,
    initialValues: {
      name: "",
      designation: "",
      email: "",
      phone_number: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().trim().required("Name is required"),
      designation: Yup.string().trim().required("Designation is required"),
      email: Yup.string()
        .trim()
        .matches(
          emailRegex,
          "Enter a valid email address (e.g., name@example.com)",
        )
        .required("Email is required"),
      phone_number: Yup.string()
        .trim()
        .required("Contact person phone no is required"),
    }),
    onSubmit: async (values) => {
      supplierDetailsFormik?.setFieldValue("contacts", [
        ...supplierDetailsFormik?.values?.contacts,
        {
          name: values.name.trim(),
          designation: values.designation.trim(),
          email: values.email.trim(),
          phone_number: values.phone_number.trim(),
        },
      ]);
      contactPersonTableFormik.resetForm();
    },
  });

  const [items, setItems] = useState<ItemRow[]>([]);
  const [gst_details, set_gst_details] = useState<any>([]);
  const [other_details, set_other_details] = useState<any>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const otherfileInputRef = useRef<HTMLInputElement>(null);

  // Track document changes for edit mode
  const [documentChanges, setDocumentChanges] = useState<{
    pan_document?: "file" | "url" | "removed" | "unchanged";
    gst_document?: "file" | "url" | "removed" | "unchanged";
    cin_document?: "file" | "url" | "removed" | "unchanged";
  }>({});

  const kycDetailsFormik = useFormik<kycDetailsFormikTypes>({
    enableReinitialize: true,
    initialValues: {
      is_kyc_approved: false,
      is_pan_details: false,
      pan_document_name: "",
      pan_document: "",
      is_gst_details: false,
      gst_document_name: "",
      gst_document: "",
      is_cin_details: false,
      cin_document_name: "",
      cin_document: "",
      is_other_details: false,
    },
    validationSchema: Yup.object({
      is_kyc_approved: Yup.boolean(),
      is_pan_details: Yup.boolean(),
      pan_document_name: Yup.string()
        .trim()
        .when("is_pan_details", {
          is: true,
          then: (schema) => schema.required("Pan No. is required"),
          otherwise: (schema) => schema.notRequired(),
        })
        .matches(panRegex, "Enter valid PAN number (e.g., ABCDE1234F)"),
      pan_document: Yup.mixed().when("is_pan_details", {
        is: true,
        then: (schema) =>
          schema.test(
            "file-or-url",
            "Pan Document is required",
            function (value) {
              // In edit mode, allow URL strings; in create mode, require file
              if (isEdit && typeof value === "string" && value.length > 0) {
                return true; // URL is acceptable
              }
              return (
                value instanceof File ||
                (typeof value === "string" && value.length > 0)
              );
            },
          ),
        otherwise: (schema) => schema.notRequired(),
      }),
      is_gst_details: Yup.boolean(),
      gst_document_name: Yup.string()
        .trim()
        .when("is_gst_details", {
          is: true,
          then: (schema) => schema.required("GST Number is required"),
          otherwise: (schema) => schema.notRequired(),
        })
        .matches(gstRegex, "Enter valid GST number (e.g., 27ABCDE1234F1Z5)"),
      gst_document: Yup.mixed().when("is_gst_details", {
        is: true,
        then: (schema) =>
          schema.test(
            "file-or-url",
            "GST Document is required",
            function (value) {
              if (isEdit && typeof value === "string" && value.length > 0) {
                return true;
              }
              return (
                value instanceof File ||
                (typeof value === "string" && value.length > 0)
              );
            },
          ),
        otherwise: (schema) => schema.notRequired(),
      }),
      is_cin_details: Yup.boolean(),
      cin_document_name: Yup.string()
        .trim()
        .when("is_cin_details", {
          is: true,
          then: (schema) => schema.required("CIN No. is required"),
          otherwise: (schema) => schema.notRequired(),
        })
        .matches(
          cinRegex,
          "Enter valid CIN number (e.g., L12345MH2023PTC123456)",
        ),
      cin_document: Yup.mixed().when("is_cin_details", {
        is: true,
        then: (schema) =>
          schema.test(
            "file-or-url",
            "CIN Document is required",
            function (value) {
              if (isEdit && typeof value === "string" && value.length > 0) {
                return true;
              }
              return (
                value instanceof File ||
                (typeof value === "string" && value.length > 0)
              );
            },
          ),
        otherwise: (schema) => schema.notRequired(),
      }),
      is_other_details: Yup.boolean(),
    }),
    onSubmit: async (values) => {
      if (values?.is_other_details && other_details?.length === 0) {
        if (activeTab === "kyc") {
          showCustomSwal({
            icon: "warning",
            text: "At least One other document is required",
          });
        } else {
          showCustomSwal({
            icon: "warning",
            text: "Please fill out the Item and KYC forms completely.",
          });
        }
        return;
      }

      setActiveTab("branch");
    },
  });

  // Track document changes when files are selected or removed (after kycDetailsFormik is declared)
  useEffect(() => {
    if (!isEdit) return;

    const panDoc = kycDetailsFormik.values.pan_document;
    if (panDoc instanceof File) {
      setDocumentChanges((prev) => ({ ...prev, pan_document: "file" }));
    } else if (panDoc === "" || panDoc === null) {
      if (originalDocuments.pan_document_url) {
        setDocumentChanges((prev) => ({ ...prev, pan_document: "removed" }));
      }
    } else if (
      typeof panDoc === "string" &&
      panDoc === originalDocuments.pan_document_url
    ) {
      setDocumentChanges((prev) => ({ ...prev, pan_document: "unchanged" }));
    } else if (
      typeof panDoc === "string" &&
      panDoc !== originalDocuments.pan_document_url
    ) {
      setDocumentChanges((prev) => ({ ...prev, pan_document: "url" }));
    }

    const gstDoc = kycDetailsFormik.values.gst_document;
    if (gstDoc instanceof File) {
      setDocumentChanges((prev) => ({ ...prev, gst_document: "file" }));
    } else if (gstDoc === "" || gstDoc === null) {
      if (originalDocuments.gst_document_url) {
        setDocumentChanges((prev) => ({ ...prev, gst_document: "removed" }));
      }
    } else if (
      typeof gstDoc === "string" &&
      gstDoc === originalDocuments.gst_document_url
    ) {
      setDocumentChanges((prev) => ({ ...prev, gst_document: "unchanged" }));
    } else if (
      typeof gstDoc === "string" &&
      gstDoc !== originalDocuments.gst_document_url
    ) {
      setDocumentChanges((prev) => ({ ...prev, gst_document: "url" }));
    }

    const cinDoc = kycDetailsFormik.values.cin_document;
    if (cinDoc instanceof File) {
      setDocumentChanges((prev) => ({ ...prev, cin_document: "file" }));
    } else if (cinDoc === "" || cinDoc === null) {
      if (originalDocuments.cin_document_url) {
        setDocumentChanges((prev) => ({ ...prev, cin_document: "removed" }));
      }
    } else if (
      typeof cinDoc === "string" &&
      cinDoc === originalDocuments.cin_document_url
    ) {
      setDocumentChanges((prev) => ({ ...prev, cin_document: "unchanged" }));
    } else if (
      typeof cinDoc === "string" &&
      cinDoc !== originalDocuments.cin_document_url
    ) {
      setDocumentChanges((prev) => ({ ...prev, cin_document: "url" }));
    }
  }, [
    kycDetailsFormik.values.pan_document,
    kycDetailsFormik.values.gst_document,
    kycDetailsFormik.values.cin_document,
    isEdit,
    originalDocuments,
  ]);

  const gstFormik = useFormik<KYCDocumentsFormikTypes>({
    enableReinitialize: true,
    initialValues: {
      gst_no: "",
      gst_document_file: null,
    },
    validationSchema: Yup.object({
      gst_no: Yup.string()
        .trim()
        .matches(gstRegex, "Enter a valid GST Number")
        .required("GST number is required"),
      gst_document_file: Yup.string().required("Document file is required"),
    }),
    onSubmit: async (values) => {
      if (gst_details?.find((d: any) => d.gst_no === values?.gst_no)) {
        showCustomSwal({
          icon: "warning",
          text: "Same GST Number cannot be add multiple times",
        });
        return;
      }
      set_gst_details((prev: any) => [
        ...prev,
        { ...values, gst_no: values.gst_no.trim() },
      ]);

      gstFormik?.resetForm();
      gstFormik.setFieldValue("gst_document_file", null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    },
  });

  const otherDocumentTableFormik = useFormik<OthersDocumentsFormikTypes>({
    enableReinitialize: true,
    initialValues: {
      document_number: "",
      document_type: "",
      document_file: null,
    },
    validationSchema: Yup.object({
      document_type: Yup.string().trim().required("Document type is required"),
      document_number: Yup.string()
        .trim()
        .required("Document number is required"),
      document_file: Yup.string().required("Document file is required"),
    }),
    onSubmit: async (values) => {
      if (
        other_details?.find(
          (d: any) => d.document_number === values?.document_number,
        )
      ) {
        showCustomSwal({
          icon: "warning",
          text: "Same Document Number cannot be add multiple times",
        });
        return;
      }
      set_other_details((prev: any) => [
        ...prev,
        {
          ...values,
          document_number: values.document_number.trim(),
          document_type: values.document_type.trim(),
        },
      ]);
      otherDocumentTableFormik?.resetForm();
      otherDocumentTableFormik.setFieldValue("document_file", null);
      if (otherfileInputRef.current) {
        otherfileInputRef.current.value = "";
      }
    },
  });
  // =========================================================================
  // ==================Tab 3 Branch Tab States=================================
  const [branches, setBranches] = useState<BranchFormikTypes[]>([]);

  const [editBranchIndex, setEditBranchIndex] = useState(null);
  const branchFormik = useFormik<BranchFormikTypes>({
    enableReinitialize: true,
    initialValues: {
      is_primary: false,
      branch_name: "",
      branch_email: "",
      branch_phone_number: "",
      contact_name: "",
      contact_email: "",
      contact_phone_number: "",
      is_gst_details: false,
      gst_document_name: "",
      gst_document: "",
      address: "",
      pincode: "",
      city: "",
      state: "",
      country: "",
    },
    validationSchema: Yup.object({
      is_primary: Yup.boolean(),
      branch_name: Yup.string().trim().required("Branch name is required"),
      branch_email: Yup.string()
        .trim()
        .matches(
          emailRegex,
          "Enter valid email address (e.g., name@example.com)",
        )
        .required("Email is required"),
      branch_phone_number: Yup.string()
        .trim()
        .matches(/^\d{10,15}$/, "Phone number must be 10-15 digits")
        .required("Phone number is required"),
      contact_name: Yup.string().trim().required("Contact name is required"),
      contact_email: Yup.string()
        .trim()
        .matches(
          emailRegex,
          "Enter valid email address (e.g., name@example.com)",
        )
        .required("Contact email is required"),
      contact_phone_number: Yup.string()
        .trim()
        .matches(/^\d{10,15}$/, "Phone number must be 10-15 digits")
        .required("Contact phone number is required"),
      is_gst_details: Yup.boolean(),
      gst_document_name: Yup.string()
        .trim()
        .when("is_gst_details", {
          is: true,
          then: (schema) => schema.required("GST Document Name is required"),
          otherwise: (schema) => schema.notRequired(),
        })
        .matches(gstRegex, "Enter a valid GST Number"),
      gst_document: Yup.mixed().when("is_gst_details", {
        is: true,
        then: (schema) => schema.required("GST Document is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      address: Yup.string().trim().required("Address is required"),
      pincode: Yup.string()
        .trim()
        .required("Pincode is required")
        .matches(/^[1-9][0-9]{5}$/, "Enter valid pincode"),
      city: Yup.mixed().when([], {
        is: () => cities.length > 0,
        then: (schema) => schema.required("City is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      state: Yup.mixed().when([], {
        is: () => states.length > 0,
        then: (schema) => schema.required("State is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      country: Yup.mixed().required("Country is required"),
    }),
    onSubmit: async (values) => {
      const finalBranch = {
        ...values,
        branch_name: values.branch_name?.toString().trim() || "",
        branch_email: values.branch_email?.toString().trim() || "",
        branch_phone_number:
          values.branch_phone_number?.toString().trim() || "",
        contact_name: values.contact_name?.toString().trim() || "",
        contact_email: values.contact_email?.toString().trim() || "",
        contact_phone_number:
          values.contact_phone_number?.toString().trim() || "",
        gst_document_name: values.gst_document_name?.toString().trim() || "",
        address: values.address?.toString().trim() || "",
        pincode: values.pincode?.toString().trim() || "",
        country:
          typeof values.country === "object"
            ? values.country?.name || ""
            : values.country || "",
        state:
          typeof values.state === "object"
            ? values.state?.name || ""
            : values.state || "",
        city:
          typeof values.city === "object"
            ? values.city?.name || ""
            : values.city || "",
      };

      if (editBranchIndex !== null) {
        let new_branches = [...branches];
        new_branches[editBranchIndex] = { ...finalBranch };
        setBranches([...new_branches]);
        setEditBranchIndex(null);
      } else {
        setBranches((prev) => [...prev, { ...finalBranch }]);
      }
      branchFormik.resetForm();
    },
  });

  useEffect(() => {
    const country = branchFormik.values.country;
    if (country) {
      let countryIsoCode = typeof country === "object" ? country.isoCode : null;

      if (!countryIsoCode) {
        const countryName =
          typeof country === "object" ? country.name : country;
        countryIsoCode = countries.find(
          (c: any) => c.name?.toLowerCase() === countryName?.toLowerCase(),
        )?.isoCode;
      }

      if (countryIsoCode) {
        const newStates = State.getStatesOfCountry(countryIsoCode);
        setStates(newStates);
      } else {
        setStates([]);
      }
    } else {
      setStates([]);
    }
  }, [branchFormik.values.country, countries]);

  useEffect(() => {
    const country = branchFormik.values.country;
    const state = branchFormik.values.state;

    if (country && state) {
      let countryIsoCode = typeof country === "object" ? country.isoCode : null;
      let stateIsoCode = typeof state === "object" ? state.isoCode : null;

      if (!countryIsoCode) {
        const countryName =
          typeof country === "object" ? country.name : country;
        countryIsoCode = countries.find(
          (c: any) => c.name?.toLowerCase() === countryName?.toLowerCase(),
        )?.isoCode;
      }

      if (!stateIsoCode && countryIsoCode) {
        const stateName = typeof state === "object" ? state.name : state;
        stateIsoCode = State.getStatesOfCountry(countryIsoCode).find(
          (s: any) => s.name?.toLowerCase() === stateName?.toLowerCase(),
        )?.isoCode;
      }

      if (countryIsoCode && stateIsoCode) {
        const newCities = City.getCitiesOfState(countryIsoCode, stateIsoCode);
        setCities(newCities);
      } else {
        setCities([]);
      }
    } else {
      setCities([]);
    }
  }, [
    branchFormik.values.state,
    branchFormik.values.country,
    countries,
    states,
  ]);

  useScrollToFormikError(
    supplierDetailsFormik.errors,
    supplierDetailsFormik.submitCount,
    supplierDetailsFormik.isSubmitting,
  );
  useScrollToFormikError(
    kycDetailsFormik.errors,
    kycDetailsFormik.submitCount,
    kycDetailsFormik.isSubmitting,
  );
  useScrollToFormikError(
    branchFormik.errors,
    branchFormik.submitCount,
    branchFormik.isSubmitting,
  );
  useScrollToFormikError(
    contactPersonTableFormik.errors,
    contactPersonTableFormik.submitCount,
    contactPersonTableFormik.isSubmitting,
  );
  useScrollToFormikError(
    otherDocumentTableFormik.errors,
    otherDocumentTableFormik.submitCount,
    otherDocumentTableFormik.isSubmitting,
  );

  const handleBranchNext = async () => {
    if (branches.length === 0) {
      if (activeTab === "branch") {
        showCustomSwal({
          icon: "warning",
          text: "Please add at least one branch.",
        });
      } else {
        showCustomSwal({
          icon: "warning",
          text: "Please fill out the branch details forms completely.",
        });
      }
      return;
    }

    const primaryCount = branches.filter(
      (branch: any) => branch?.is_primary,
    ).length;

    if (primaryCount !== 1) {
      if (activeTab === "branch") {
        showCustomSwal({
          icon: "warning",
          text:
            primaryCount === 0
              ? "One branch must be Primary."
              : "Only one branch can be Primary.",
        });
      } else {
        showCustomSwal({
          icon: "warning",
          text: "Please fill out the branch details forms completely.",
        });
      }
      return;
    }

    setActiveTab("price");
  };

  const [products, setProducts] = useState<Item[]>([]);
  // =========================================================================

  // Load supplier data when in edit mode
  useEffect(() => {
    const loadSupplierData = async () => {
      if (isEdit && supplier_id) {
        try {
          setLoadingSupplier(true);
          const supplierData = await dispatch(
            fetchSupplierById(supplier_id) as any,
          ).unwrap();

          // Set original document URLs
          setOriginalDocuments({
            pan_document_url: supplierData.pan_document_url,
            gst_document_url: supplierData.gst_document_url,
            cin_document_url: supplierData.cin_document_url,
          });

          // Populate supplier details
          supplierDetailsFormik.setValues({
            supplier_name: supplierData.supplier_name || "",
            supplier_type: supplierData.supplier_type || "",
            on_boarding_date: supplierData.on_boarding_date
              ? new Date(supplierData.on_boarding_date)
                  .toISOString()
                  .split("T")[0]
              : "",
            email: supplierData.email || "",
            phone_number: supplierData.phone_number || "",
            contacts: supplierData.contacts || [],
          });

          // Populate KYC details
          kycDetailsFormik.setValues({
            is_kyc_approved: supplierData.is_kyc_approved || false,
            is_pan_details: supplierData.is_pan_details || false,
            pan_document_name: supplierData.pan_document_name || "",
            pan_document: supplierData.pan_document_url || "",
            is_gst_details: supplierData.is_gst_details || false,
            gst_document_name: supplierData.gst_document_name || "",
            gst_document: supplierData.gst_document_url || "",
            is_cin_details: supplierData.is_cin_details || false,
            cin_document_name: supplierData.cin_document_name || "",
            cin_document: supplierData.cin_document_url || "",
            is_other_details:
              (supplierData.other_documents &&
                supplierData.other_documents.length > 0) ||
              false,
          });

          // Set initial document changes to unchanged
          setDocumentChanges({
            pan_document: supplierData.pan_document_url
              ? "unchanged"
              : undefined,
            gst_document: supplierData.gst_document_url
              ? "unchanged"
              : undefined,
            cin_document: supplierData.cin_document_url
              ? "unchanged"
              : undefined,
          });

          // Populate other documents
          if (supplierData.other_documents) {
            set_other_details(
              supplierData.other_documents.map((doc: any) => ({
                document_type: doc.document_type,
                document_number: doc.document_number,
                document_file: doc.document_url, // Store URL for existing documents
              })),
            );
          }

          // Populate branches
          if (supplierData.branches) {
            setBranches(
              supplierData.branches.map((branch: any) => ({
                ...branch,
                city:
                  typeof branch.city === "object"
                    ? branch.city?.name
                    : branch.city || "",
                state:
                  typeof branch.state === "object"
                    ? branch.state?.name
                    : branch.state || "",
                country:
                  typeof branch.country === "object"
                    ? branch.country?.name
                    : branch.country || "",
                gst_document: branch.gst_document_url || "", // Store URL for existing documents
              })),
            );
          }

          // Populate products
          if (supplierData.products) {
            setProducts(
              supplierData.products.map((product: any) => ({
                ...product,
                model: product?.product?.model,
                item_name: product.product?.item_name || "",
                unit_name: product.unit?.unit_name || "",
                unit_price: Number(product.unit_price) || "",
                lead_time: Number(product.lead_time) || "",
                capacity: Number(product.capacity) || "",
                product_id: product.product_id,
                unit_id: product.unit_id,
              })),
            );
          }
        } catch (error: any) {
          console.error("Error loading supplier data:", error);
          toast.error(error?.message || "Failed to load supplier data");
        } finally {
          setLoadingSupplier(false);
        }
      }
    };

    loadSupplierData();
  }, [isEdit, supplier_id, dispatch]);

  const final_submit = async () => {
    const payload: any = {
      ...supplierDetailsFormik?.values,
      ...kycDetailsFormik?.values,
      other_documents: other_details,
      branches: branches?.map((branch: any) => ({
        ...branch,
        city:
          typeof branch?.city === "object" ? branch?.city?.name : branch?.city,
        country:
          typeof branch?.country === "object"
            ? branch?.country?.name
            : branch?.country,
        state:
          typeof branch?.state === "object"
            ? branch?.state?.name
            : branch?.state,
      })),
      products: products,
    };

    const formData = new FormData();

    // Required fields
    formData.append("supplier_name", payload?.supplier_name.trim());
    formData.append("supplier_type", payload?.supplier_type);
    formData.append("on_boarding_date", payload?.on_boarding_date);
    formData.append("phone_number", payload?.phone_number.trim());
    formData.append("email", payload?.email.trim());

    // Optional document flags
    formData.append("is_kyc_approved", payload?.is_kyc_approved);
    formData.append("is_pan_details", payload?.is_pan_details);
    formData.append("is_gst_details", payload?.is_gst_details);
    formData.append("is_cin_details", payload?.is_cin_details);

    // Handle PAN document
    if (isEdit) {
      const panChange = documentChanges.pan_document;
      if (panChange === "file" && payload?.pan_document instanceof File) {
        // New file uploaded
        formData.append("pan_document", payload.pan_document);
        formData.append("pan_document_name", payload.pan_document_name.trim());
      } else if (
        panChange === "url" &&
        typeof payload?.pan_document === "string"
      ) {
        // Existing URL (no change)
        formData.append("pan_document_url", payload.pan_document);
        formData.append("pan_document_name", payload.pan_document_name.trim());
      } else if (panChange === "removed") {
        // Document removed
        formData.append("pan_document_url", "");
        formData.append("pan_document_name", "");
      } else if (
        panChange === "unchanged" &&
        originalDocuments.pan_document_url
      ) {
        // Keep existing
        formData.append("pan_document_url", originalDocuments.pan_document_url);
        formData.append("pan_document_name", payload.pan_document_name.trim());
      }
    } else {
      // Create mode - always send file if exists
      if (payload?.pan_document) {
        formData.append("pan_document", payload.pan_document);
        formData.append("pan_document_name", payload.pan_document_name.trim());
      }
    }

    // Handle GST document
    if (isEdit) {
      const gstChange = documentChanges.gst_document;
      if (gstChange === "file" && payload?.gst_document instanceof File) {
        formData.append("gst_document", payload.gst_document);
        formData.append("gst_document_name", payload.gst_document_name.trim());
      } else if (
        gstChange === "url" &&
        typeof payload?.gst_document === "string"
      ) {
        formData.append("gst_document_url", payload.gst_document);
        formData.append("gst_document_name", payload.gst_document_name.trim());
      } else if (gstChange === "removed") {
        formData.append("gst_document_url", "");
        formData.append("gst_document_name", "");
      } else if (
        gstChange === "unchanged" &&
        originalDocuments.gst_document_url
      ) {
        formData.append("gst_document_url", originalDocuments.gst_document_url);
        formData.append("gst_document_name", payload.gst_document_name.trim());
      }
    } else {
      if (payload?.gst_document) {
        formData.append("gst_document", payload.gst_document);
        formData.append("gst_document_name", payload.gst_document_name.trim());
      }
    }

    // Handle CIN document
    if (isEdit) {
      const cinChange = documentChanges.cin_document;
      if (cinChange === "file" && payload?.cin_document instanceof File) {
        formData.append("cin_document", payload.cin_document);
        formData.append("cin_document_name", payload.cin_document_name.trim());
      } else if (
        cinChange === "url" &&
        typeof payload?.cin_document === "string"
      ) {
        formData.append("cin_document_url", payload.cin_document);
        formData.append("cin_document_name", payload.cin_document_name.trim());
      } else if (cinChange === "removed") {
        formData.append("cin_document_url", "");
        formData.append("cin_document_name", "");
      } else if (
        cinChange === "unchanged" &&
        originalDocuments.cin_document_url
      ) {
        formData.append("cin_document_url", originalDocuments.cin_document_url);
        formData.append("cin_document_name", payload.cin_document_name.trim());
      }
    } else {
      if (payload?.cin_document) {
        formData.append("cin_document", payload.cin_document);
        formData.append("cin_document_name", payload.cin_document_name.trim());
      }
    }

    formData.append("contacts", JSON.stringify(payload?.contacts));

    // Other documents with files (JSON string for structure, files separate)

    const updated_other_document = payload.other_documents?.map(
      ({ document_file, ...doc }: any, index: number) => {
        if (document_file) {
          formData.append(`other_document_${index}`, document_file);
        }
        return doc;
      },
    );
    formData.append("other_documents", JSON.stringify(updated_other_document));

    const updated_branches = payload?.branches?.map(
      ({ gst_document, ...branch }: any, index: number) => {
        if (gst_document) {
          formData.append(`gst_branch_document_${index}`, gst_document);
        }
        return branch;
      },
    );

    formData.append("branches", JSON.stringify(updated_branches));

    // Products (JSON string)
    formData.append("products", JSON.stringify(payload.products));

    setPageLoading(true);
    try {
      if (isEdit && supplier_id) {
        await dispatch(updateSupplier({ id: supplier_id, formData })).unwrap();
        toast.success("Supplier updated successfully");
        navigate("/master/supplier");
      } else {
        await dispatch(addSupplier(formData)).unwrap();
        clearTableState(TableKeys.MASTER.SUPPLIER);
        toast.success("Supplier added successfully");
        navigate("/master/supplier");
      }
    } catch (error: any) {
      toast.error(
        error?.message ||
          (isEdit ? "Failed to update supplier" : "Failed to add supplier"),
      );
    } finally {
      setPageLoading(false);
    }
  };

  return (
    <PageContainer>
      <PageBreadcrumb
        title={isEdit ? "Edit Supplier" : "Add Supplier"}
        titleLink="/master/supplier"
        breadcrumbs={[
          { label: "Supplier", to: "/master/supplier" },
          { label: isEdit ? "Edit Supplier" : "Add Supplier", to: "" },
        ]}
        backNavigationPath={-1}
      />
      <hr />

      {pageLoading || loadingSupplier ? (
        <LoadingSpinner />
      ) : (
        <>
          <Box>
            <Tabs
              value={
                activeTab === "supplier"
                  ? 0
                  : activeTab === "kyc"
                    ? 1
                    : activeTab === "branch"
                      ? 2
                      : 3
              }
              sx={{
                "& .MuiTab-root": {
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "14px",
                  textTransform: "none", // optional (prevents uppercase)
                  color: MecordColors.DefaultText,

                  "&.Mui-selected": {
                    color: MecordColors.ThemeBGColor,
                    fontWeight: 500, // optional
                  },
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: MecordColors.ThemeBGColor,
                },
              }}
              onChange={(event, newValue) => {
                if (newValue === 0) {
                  setActiveTab("supplier");
                } else if (newValue === 1) {
                  // Validate supplier details before allowing navigation to KYC tab
                  supplierDetailsFormik.validateForm().then((errors) => {
                    if (Object.keys(errors).length > 0) {
                      // Check if contacts array is empty
                      if (supplierDetailsFormik.values.contacts?.length === 0) {
                        showCustomSwal({
                          icon: "warning",
                          text: "Please fill Supplier Details completely. At least one contact person is required.",
                        });
                        return;
                      }
                      showCustomSwal({
                        icon: "warning",
                        text: "Please fill Supplier Details completely.",
                      });
                      return;
                    }
                    setActiveTab("kyc");
                  });
                } else if (newValue === 2) {
                  // Validate both supplier and KYC details before allowing navigation to Branch tab
                  supplierDetailsFormik
                    .validateForm()
                    .then((supplierErrors) => {
                      if (Object.keys(supplierErrors).length > 0) {
                        // Check if contacts array is empty
                        if (
                          supplierDetailsFormik.values.contacts?.length === 0
                        ) {
                          showCustomSwal({
                            icon: "warning",
                            text: "Please fill Supplier Details completely. At least one contact person is required.",
                          });
                          return;
                        }
                        showCustomSwal({
                          icon: "warning",
                          text: "Please fill Supplier Details completely.",
                        });
                        return;
                      }

                      // Now validate KYC details
                      kycDetailsFormik.validateForm().then((kycErrors) => {
                        if (Object.keys(kycErrors).length > 0) {
                          showCustomSwal({
                            icon: "warning",
                            text: "Please fill KYC details completely.",
                          });
                          return;
                        }
                        setActiveTab("branch");
                      });
                    });
                } else if (newValue === 3) {
                  // Validate supplier, KYC, and branch details before allowing navigation to Product tab
                  supplierDetailsFormik
                    .validateForm()
                    .then((supplierErrors) => {
                      if (Object.keys(supplierErrors).length > 0) {
                        // Check if contacts array is empty
                        if (
                          supplierDetailsFormik.values.contacts?.length === 0
                        ) {
                          showCustomSwal({
                            icon: "warning",
                            text: "Please fill Supplier Details completely. At least one contact person is required.",
                          });
                          return;
                        }
                        showCustomSwal({
                          icon: "warning",
                          text: "Please fill Supplier Details completely.",
                        });
                        return;
                      }

                      // Check KYC validation
                      kycDetailsFormik.validateForm().then((kycErrors) => {
                        if (Object.keys(kycErrors).length > 0) {
                          showCustomSwal({
                            icon: "warning",
                            text: "Please fill KYC details completely.",
                          });
                          return;
                        }

                        // Check branch validation
                        if (branches.length === 0) {
                          showCustomSwal({
                            icon: "warning",
                            text: "Please add at least one branch detail.",
                          });
                          return;
                        }

                        setActiveTab("price");
                      });
                    });
                }
              }}
              aria-label="supplier form tabs"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Supplier Details" />
              <Tab label="KYC" />
              <Tab label="Branch Details" />
              <Tab label="Product Details" />
            </Tabs>

            {/* Tab Content */}
            <Box sx={{ mt: 2 }}>
              {activeTab === "supplier" && (
                <SupplierDetails
                  supplierDetailsFormik={supplierDetailsFormik}
                  contactPersonTableFormik={contactPersonTableFormik}
                />
              )}
              {activeTab === "kyc" && (
                <KYCDetails
                  goToTab={setActiveTab}
                  kycDetailsFormik={kycDetailsFormik}
                  other_details={other_details}
                  set_other_details={set_other_details}
                  otherfileInputRef={otherfileInputRef}
                  otherDocumentTableFormik={otherDocumentTableFormik}
                />
              )}
              {activeTab === "branch" && (
                <BranchDetails
                  goToTab={setActiveTab}
                  branches={branches}
                  setBranches={setBranches}
                  branchFormik={branchFormik}
                  editBranchIndex={editBranchIndex}
                  setEditBranchIndex={setEditBranchIndex}
                  handleBranchNext={handleBranchNext}
                  countries={countries}
                  setCountries={setCountries}
                  states={states}
                  setStates={setStates}
                  cities={cities}
                  setCities={setCities}
                />
              )}
              {activeTab === "price" && (
                <ProductDetails
                  goToTab={setActiveTab}
                  itemUnitsRaw={items}
                  products={products}
                  setProducts={setProducts}
                  final_submit={final_submit}
                />
              )}
            </Box>
          </Box>
        </>
      )}
    </PageContainer>
  );
};

export default SupplierForm;
